import ApiClient from '../../base/api';
import { FindCityRequestParams } from '../../base/interfaces/api';
import { City } from '../../base/interfaces/config';
import { SendVerificationSMSParams, ConfigResponse } from './interfaces';

const apiClient = new ApiClient();

export const workerApi = {
    favoritesToggle: (id: number, value: boolean) => {
        return apiClient.post(`/api/${id}/favorite`, { favorite: value });
    },
    getConfig: () => apiClient.get<ConfigResponse>('/api/config'),
    sendVerificationSMS: (data: SendVerificationSMSParams) =>
        apiClient.post<SendVerificationSMSParams, void>('/api/send-sms', data),
    findCity: (data: FindCityRequestParams, signal?: AbortSignal) =>
        apiClient.post<FindCityRequestParams, City[]>('/api/find-city ', data, { signal }),
};
